import { getFileListApi } from '@/api/publicAxios/publicAxios'
// 统一处理图片问题

/**
 * 同 subKind 多条附件时取最新。
 * 列表接口 orderByAsc(sort).orderByAsc(createdTime)，匹配结果末条即最新；
 * 另按 sort 兜底（VO 无 createdTime 时仍可用）。
 */
export function I_PickLatestBySubKind<T extends { subKind?: string; fileId?: string; sort?: number }>(
  fileList: T[] = [],
  subKind: string
): T | null {
  const matched = (fileList || []).filter((file) => file?.subKind == subKind && file?.fileId)
  if (!matched.length) return null
  return matched.reduce((best, cur) => {
    const bestSort = Number(best.sort ?? 0)
    const curSort = Number(cur.sort ?? 0)
    if (curSort !== bestSort) return curSort > bestSort ? cur : best
    // sort 相同则保留后出现的（接口升序末条更新）
    return cur
  })
}

/**
 * 根据表单配置和字段名匹配，设置对应附件组件的previewFileId
 * @param schemaList 表单配置数组
 * @param fieldName 需要处理的字段名称（单个字符串或字符串数组）
 * @param fileList 文件列表，包含subKind和fileId信息
 * @returns 处理后的schemaList
 */
export function I_SetFileIdBySubKind(schemaList: any[], fileList: Array<any> = [], bizId?: string) {
  // 创建新的数组避免直接修改原数组
  const newSchemaList = [...schemaList]
  newSchemaList.forEach((item) => {
    if (item.component === 'UploadType' && item.componentProps) {
      // 设置bizId
      if (bizId !== undefined) {
        item.componentProps.bizId = bizId
      }
      // 获取组件的subKind
      const componentSubKind = item.componentProps.subKind
      // 如果fileList为空数组或者没有匹配的subKind，则清空previewFileId
      const matchedFile = componentSubKind ? I_PickLatestBySubKind(fileList, componentSubKind) : null
      if (!fileList.length || !componentSubKind || !matchedFile) {
        item.componentProps.previewFileId = ''
      } else {
        item.componentProps.previewFileId = matchedFile.fileId || ''
      }
    }
  })
  return newSchemaList
}

// 封装统一方法根据bizFileId获取文件列表
export const I_GetFileListByBizId = async (bizFileId: string, bizKind: string) => {
  if (!bizFileId) return []
  try {
    const res = await getFileListApi(bizFileId, bizKind)
    if (res.code == 0) {
      return res.data
    } else {
      return []
    }
  } catch (error) {
    return []
  }
}

/**
 * 清理上传组件的图片
 * @param getComponentExpose 获取组件暴露方法的函数
 * @param fieldList 需要清理的字段名称，可以是字符串或字符串数组
 */
export const I_ClearUploadImages = async (
  getComponentExpose: Function,
  fieldList: string[] = []
) => {
  if (!Array.isArray(fieldList) || !fieldList.length) {
    return
  }
  // 遍历字段数组，逐个清理图片
  for (const field of fieldList) {
    try {
      const component = await getComponentExpose(field)
      if (component && typeof component.clearImg === 'function') {
        component.clearImg()
      }
    } catch (error) {
      console.warn(`清理上传组件图片失败，字段: ${field}`, error)
    }
  }
}
